import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';

import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, ResponsiveContainer } from 'recharts';
import { twomonthusage } from '../../helpers/api';

function MonthBarChart() {

    const data = [
        {
            name: 'Page A',
            uv: 4000,
            pv: 2400,
            amt: 2400,
        },
        {
            name: 'Page B',
            uv: 3000,
            pv: 1398,
            amt: 2210,
        },
        {
            name: 'Page C',
            uv: 2000,
            pv: 9800,
            amt: 2290,
        },
        {
            name: 'Page D',
            uv: 2780,
            pv: 3908,
            amt: 2000,
        },
        {
            name: 'Page E',
            uv: 1890,
            pv: 4800,
            amt: 2181,
        },
        {
            name: 'Page F',
            uv: 2390,
            pv: 3800,
            amt: 2500,
        },
        {
            name: 'Page G',
            uv: 3490,
            pv: 4300,
            amt: 2100,
        },
    ];


    // const [data, setData] = useState([])

    // const getData = async () => {
    //     try {
    //         const response = await twomonthusage()
    //         console.log("tmmMMM", response);
    //         setData(response.message)
    //     }
    //     catch (e) {
    //         console.log(e);
    //     }

    // }

    // useEffect(() => {
    //     getData()
    // }, [])

    return (
        <>
            <div className='monthBarChart' style={{ height: "300px", width: "300px" }}>
                {/* <ResponsiveContainer className="SimpleArea_BarChart" width={"100%"} height="100%">
                    <BarChart
                        width={900}
                        height={250}
                        data={data}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="pv" fill="#8F43EE" />
                        <Bar dataKey="uv" fill="#E7D4FF" />
                    </BarChart>
                </ ResponsiveContainer> */}

                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={300}
                        data={data}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                        barSize={50}
                    >
                        <XAxis dataKey="name" scale="point" padding={{ left: 20, right: 20 }} />
                        {/* <YAxis /> */}
                        <Tooltip />
                        {/* <Legend /> */}
                        <CartesianGrid strokeDasharray="3 3" />
                        <Bar dataKey="pv" fill="#8F43EE" />
                        <Bar dataKey="uv" fill="#E7D4FF" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </>
    )
}

export default MonthBarChart